import {
    AMC_INCIDENT_DETAILS_SET_VALUE,
    AMC_INCIDENT_DETAILS_SET_VALID,
    AMC_FORM_INVALID_TRANSITION_INCIDENT_DETAILS,
    AMC_FORM_VALID_TRANSITION_INCIDENT_DETAILS,
} from '../../actions/allSureMotorClaim/incidentDetails';
import { INCIDENT_DETAIL_LABELS, RADIO_OPTION } from '../../actions/allSureMotorClaim/types';
import { getBasicDetailsForm } from '../../selectors/allSureMotorClaim/basicDetails';
import { FIELD_STATUS, FORM_STATUS } from '../status';

const calculateDaysFromDate = (incidentDate) => {
    const [day, month, year] = incidentDate.split('/').map(Number);
    const incident = new Date(year, month - 1, day);
    const currentDate = new Date();
    const timeDiff = currentDate - incident;
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return days;
};
export const initIncidentDetails = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        vehicleMake: { value: null, error: null, status: null, displayValue: null },
        mentionedVehicleMake: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'vehicleMake',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === 'OTHER',
        },
        vehicleModel: { value: null, error: null, status: null, displayValue: null },
        mentionedVehicleModel: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'vehicleModel',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === 'OTHER',
        },
        registrationNumber: { value: null, error: null, status: null, displayValue: null },
        vehicleYear: { value: null, error: null, status: null, displayValue: null },
        creditAgreement: { value: null, error: null, status: null, displayValue: null },
        nameOfFinance: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'creditAgreement',
        },
        addressOfFinance: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'creditAgreement',
        },
        nameOfVehicleRegistration: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'creditAgreement',
        },
        dateOfIncident: {
            value: null,
            error: null,
            status: null,
        },
        reasonForDelay: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'dateOfIncident',
            validationCondition: (currentfield, dependentField) =>
                dependentField.value && calculateDaysFromDate(dependentField.value) >= 30 && calculateDaysFromDate(dependentField.value) <= 1096,
        },
        timeOfIncident: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
        },
        addressOrLocation: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
        },
        windScreenType: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
        },
        causeOfBreakage: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
        },
        personResponsible: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
        },

        driverName: { value: null, error: null, status: null, displayValue: null },
        driverLicense: { value: null, error: null, status: null, displayValue: null },
        driverLicenseNumber: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'driverLicense',
            validationCondition: (currentfield, dependentField) =>
                dependentField.value === 'Full' || dependentField.value === 'Learner',
        },
        driverLicenseCode: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'driverLicense',
            validationCondition: (currentfield, dependentField) =>
                dependentField.value === 'Full' || dependentField.value === 'Learner',
        },
        thirdParty: { value: null, error: null, status: null, displayValue: null },
        thirdPartyName: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'thirdParty',
        },
        thirdPartyNumber: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'thirdParty',
        },
        thirdPartyAddress: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'thirdParty',
        },
        thirdPartyEmail: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'thirdParty',
        },
        personToBeKeptInformed: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
        personsFullName: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: null,
            dependentField: 'personToBeKeptInformed',
            validationCondition: (currentfield, dependentField) =>
                ['Family', 'Friends'].includes(dependentField?.value),
        },
        personsContact: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: null,
            dependentField: 'personToBeKeptInformed',
            validationCondition: (currentfield, dependentField) =>
                ['Family', 'Friends'].includes(dependentField?.value),
        },
        personsEmail: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: null,
            dependentField: 'personToBeKeptInformed',
            validationCondition: (currentfield, dependentField) =>
                ['Family', 'Friends'].includes(dependentField?.value),
        },
        witness: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
        mileage: { value: null, error: null, status: null, displayValue: null },
        vehicleIdNumber: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
        chassisNumber: { value: null, error: null, status: null, displayValue: null },
        engineNumber: { value: null, error: null, status: null, displayValue: null },
        exteriorColor: { value: null, error: null, status: null, displayValue: null },
        interiorColor: { value: null, error: null, status: null, displayValue: null },
        grossVehicleMass: { value: null, error: null, status: null, displayValue: null },
        tare: { value: null, error: null, status: null, displayValue: null },
        vehicleValue: { value: null, error: null, status: null, displayValue: null },
        dateOfPurchase: { value: null, error: null, status: null, displayValue: null },
        kiloMeterCompleted: { value: null, error: null, status: null, displayValue: null },
        dateOfAccident: {
            value: null,
            error: null,
            status: null,
        },
        reasonForDelayAccident: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'dateOfAccident',
            validationCondition: (currentfield, dependentField) =>
                dependentField.value && calculateDaysFromDate(dependentField.value) >= 30 && calculateDaysFromDate(dependentField.value) <= 1096,
        },
        timeOfIncidentAccident: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
        },

        addressOrLocationAccident: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
        },
        speedBeforeImpact: { value: null, error: null, status: null, displayValue: null },
        speedAfterImpact: { value: null, error: null, status: null, displayValue: null },
        weatherCondition: { value: null, error: null, status: null, displayValue: null },
        // otherWeatherCondition: { value: null, error: null, status:  null, displayValue: null },
        visibilityAtTheTimeOfIncident: { value: null, error: null, status: null, displayValue: null },
        otherVisibility: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentField: 'visibilityAtTheTimeOfIncident',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === 'Other',
        },
        roadSurfaceType: { value: null, error: null, status: null, displayValue: null },
        widthOfRoad: { value: null, error: null, status: null, displayValue: null },
        vehicleLightIncident: { value: null, error: null, status: null, displayValue: null },
        streetLight: { value: null, error: null, status: null, displayValue: null },
        warning: { value: null, error: null, status: null, displayValue: null },
        anyPassenger: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
        passenger: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null,
            dependentField: 'anyPassenger',
            validationCondition: (currentField, dependentField) =>
            dependentField.value && dependentField?.value === RADIO_OPTION.YES,
         },
        employee: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null,
            dependentField: 'anyPassenger',
            validationCondition: (currentField, dependentField) =>
            dependentField.value && dependentField?.value === RADIO_OPTION.YES,
         },
        purpose: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null,
            dependentField: 'anyPassenger',
            validationCondition: (currentField, dependentField) =>
            dependentField.value && dependentField?.value === RADIO_OPTION.YES,
         },
    },
};
const defaultFieldState = () => ({
    value: null,
    error: null,
    status: null,
    displayValue: null,
});
export default (state = initIncidentDetails, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    switch (action.type) {
        case AMC_FORM_VALID_TRANSITION_INCIDENT_DETAILS:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case AMC_FORM_INVALID_TRANSITION_INCIDENT_DETAILS:
            return { ...state, formStatus: FORM_STATUS.INVALID };
        case AMC_INCIDENT_DETAILS_SET_VALUE:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                displayValue: action.value.displayValue ?? action.value.value,
                value: action.value.value,
            }));

        case AMC_INCIDENT_DETAILS_SET_VALID:
            const { fieldType, error } = action;
            return updateFormField(fieldType, (field) => ({
                ...field,
                error: error,
                status: mapError(error),
            }));

        case 'UPDATE_WITNESS_COUNT': {
            const witnessCount = action.payload;
            const updatedForm = { ...state.form };

            Object.keys(updatedForm).forEach((key) => {
                if (/^witness(Name|Phone|Address)_\d+$/.test(key)) {
                    delete updatedForm[key];
                }
            });
            if (!witnessCount || witnessCount === 'None') {
                return {
                    ...state,
                    form: {
                        ...updatedForm,
                    },
                };
            }

            for (let i = 1; i <= witnessCount; i++) {
                updatedForm[`witnessName_${i}`] = defaultFieldState();
                updatedForm[`witnessAddress_${i}`] = defaultFieldState();
                updatedForm[`witnessPhone_${i}`] = defaultFieldState();
            }

            return {
                ...state,
                form: {
                    ...updatedForm,
                    witness: {
                        value: witnessCount,
                        error: null,
                        status: null,
                        displayValue: witnessCount,
                    },
                },
            };
        }

        case 'UPDATE_WITNESS_DETAILS': {
            const { field, value, displayValue } = action.payload;

            return {
                ...state,
                form: {
                    ...state.form,
                    [field]: {
                        ...(state.form[field] || { value: null, error: null, status: null, displayValue: null }),
                        value,
                        displayValue,
                    },
                },
            };
        }

        case 'UPDATE_PASSENGER_COUNT': {
            const passengerCount = action.payload;
            const updatedForm = { ...state.form };

            Object.keys(updatedForm).forEach((key) => {
                if (/^passenger(Name|Address|Injury)_\d+$/.test(key)) {
                    delete updatedForm[key];
                }
            });
            if (!passengerCount || passengerCount === 'None') {
                return {
                    ...state,
                    form: {
                        ...updatedForm,
                    },
                };
            }

            for (let i = 1; i <= passengerCount; i++) {
                updatedForm[`passengerName_${i}`] = defaultFieldState();
                updatedForm[`passengerAddress_${i}`] = defaultFieldState();
                updatedForm[`passengerInjury_${i}`] = defaultFieldState();
            }

            return {
                ...state,
                form: {
                    ...updatedForm,
                    passenger: {
                        value: passengerCount,
                        error: null,
                        status: null,
                        displayValue: passengerCount,
                    },
                },
            };
        }

        case 'UPDATE_PASSENGER_DETAILS': {
            const { field, value, displayValue } = action.payload;

            return {
                ...state,
                form: {
                    ...state.form,
                    [field]: {
                        ...(state.form[field] || { value: null, error: null, status: null, displayValue: null }),
                        value,
                        displayValue,
                    },
                },
            };
        }

        default:
            return state;
    }
};
